export default __webpack_public_path__ + "static/media/rejection.191c1bc4.png";